import initContainer from '@99designs/brand-container/index';
import relativeTime from '@99designs/brand-container/lib/ui/relative-time';
import '@99designs/asimov-promo-bar/index';
import $ from 'jquery';
import { assign } from 'lodash';

//
// Create a hidden promotion bar that only displays if a promotion is active.
//
function initPromoBar() {
    let $bar = $('<div />')
            .attr('data-use-carousel-color', true)
            .attr('data-promo-bar', true)
            .attr('data-promo-bar-endpoint', '/noticebar')
            .attr('data-state', 'hidden');

    $bar.promoBar();
    $('[data-oc-canvas]').prepend($bar);
}

//
// Initialise platform services
//
export default function initialise() {
    if (!document.querySelector('[data-globalnavui]')) {
        return;
    }

    const options = $('[data-globalnavui]').data();

    initContainer();
    relativeTime.attachTo('html');

    if (options.promoBar) {
        initPromoBar();
    }
}



/** WEBPACK FOOTER **
 ** ./js/common/components/globalNav.js
 **/